<template>
  <div v-if="socials.length" class="d-flex">
    <a
      v-for="({ needHost = false, network, url = '', target = '_blank', html, className = '' }, index) in socials"
      :key="index"
      :href="generateUrl(needHost, network, url)"
      :target="target"
      :class="className"
    >
      <span v-if="html && html.length" v-html="html"></span>
    </a>
  </div>
</template>

<script>
/**
 * @class SocialShare
 *
 * @description sharing content in social media (facebook, linkedin)
 */
export default {
  name: 'SocialShare',
  props: {
    socials: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      networks: {
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=@url',
        linkedin: 'http://www.linkedin.com/shareArticle?url=@url',
      },
    }
  },
  methods: {
    generateUrl(needHost, network, url) {
      url = url || window.location.href
      const surl = needHost ? window.location.protocol + '//' + window.location.hostname + url : url
      return this.networks[network].replace(/@url/g, encodeURIComponent(surl))
    },
  },
}
</script>
